module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"bsModalRef.hide()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <iframe [src]=\"endPoint()\" frameborder=\"0\" width=\"100%\" height=\"550\" allowtransparency='true' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/modals/reporte-modal/reporte-modal.component.html
// module id = ../../../../../src/app/components/modals/reporte-modal/reporte-modal.component.html
// module chunks = main